//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Multiselect from 'vue-multiselect'
import SupervisorValidationTable from './SupervisorValidation/SupervisorValidationTable.vue'
import ModalValidatedSkills from './SupervisorValidation/ModalValidatedSkills.vue'
import ModalMetricsBySkills from './SupervisorValidation/ModalMetricsBySkills.vue'
import ModalMetricsBySkillPacks from './SupervisorValidation/ModalMetricsBySkillPacks.vue'

export default {
  name: 'SupervisorsValidationTab',
  components: {
    SupervisorValidationTable,
    Multiselect,
    ModalValidatedSkills,
    ModalMetricsBySkills,
    ModalMetricsBySkillPacks,
  },
  props: {
    project: {
      type: Object,
      default: () => ({}),
    },
  },
  async fetch() {
    this.$store.commit('loading', true)
    this.supervisors = await this.$repository.user.findSupervisorsByProject({
      project: this.project.id,
    })
    this.entities = await this.$repository.project.getEntities(this.project.id)
    if (this.entitiesFormatted[0]) {
      this.filters.entity = this.entitiesFormatted[0]
      await this.refreshData()
    }

    this.$store.commit('loading', false)
  },
  data() {
    return {
      filters: {
        term: '',
        supervisor: null,
        entity: null,
      },
      supervisors: [],
      collaboratorsMetrics: [],
      isShowModalValidatedSkills: false,
      skillsValidationsWithUsers: {},
      isShowModalMetricsBySkills: false,
      metricsValidationBySkills: {},
      isShowModalMetricsBySkillPacks: false,
      metricsValidationBySkillPacks: {},
      entities: [],
    }
  },
  computed: {
    formattedCollaborators() {
      return this.collaboratorsMetrics
        .filter((collaborator) => {
          const termMatch = collaborator.collaborator
            .toLowerCase()
            .includes(this.filters.term.toLowerCase())
          const supervisorMatch =
            !this.filters.supervisor ||
            collaborator.supervisor_id === this.filters.supervisor.value
          return termMatch && supervisorMatch
        })
        .map((collaborator) => ({
          ...collaborator,
          disparity: Number(
            (
              Number(collaborator.supervisor_match) -
              Number(collaborator.collaborator_match)
            ).toFixed(2)
          ),
        }))
    },
    supervisorsFormatted() {
      return this.supervisors.map((supervisor) => ({
        value: supervisor.id,
        label: `${supervisor.names} ${supervisor.lastnames}`,
      }))
    },
    entitiesFormatted() {
      return this.entities.map((entity) => ({
        value: entity,
        label:
          entity.type === 'occupation'
            ? `Vista de perfil`
            : `Vista ${entity.name}`,
      }))
    },
    selectedEntityValue() {
      return this.filters.entity?.value
    },
  },
  watch: {
    'filters.entity'() {
      if (!this.filters.entity && this.entitiesFormatted[0]) {
        this.filters.entity = this.entitiesFormatted[0]
      }
      this.refreshData()
    },
  },
  methods: {
    toggleModalValidatedSkills() {
      this.isShowModalValidatedSkills = !this.isShowModalValidatedSkills
    },
    async handleSkillsValidations(supervisorAssignment) {
      this.skillsValidationsWithUsers = await this.$repository.skillsValidations.findSkillsValidatedDetailBySupervisorAssignmentId(
        supervisorAssignment.id
      )
      this.isShowModalValidatedSkills = true
    },
    async handleShowMetricsOfSkill(supervisorAssignment) {
      this.metricsValidationBySkills = await this.$repository.supervisorAssignments.getStatsSkillsByModel(
        supervisorAssignment.id,
        { model_id: this.selectedEntityValue.id }
      )
      this.isShowModalMetricsBySkills = true
    },
    async handleShowMetricsOfSkillPacks(supervisorAssignment) {
      const baseInfo = await this.$repository.supervisorAssignments.getStatsSkillPacksByModel(
        supervisorAssignment.id,
        { model_id: this.selectedEntityValue.id }
      )
      this.metricsValidationBySkillPacks = {
        ...baseInfo,
        skillPackValidations: baseInfo.skillPackValidations.map((sp) => ({
          ...sp,
          disparity: Number(
            (
              Number(sp.supervisor_match) - Number(sp.collaborator_match)
            ).toFixed(2)
          ),
        })),
      }
      this.isShowModalMetricsBySkillPacks = true
    },
    async refreshData() {
      if (!this.filters.entity) {
        return
      }
      this.$store.commit('loading', true)
      this.collaboratorsMetrics = await this.$repository.supervisorAssignments.getCollaboratorValidationMetricsByProjectId(
        this.project.id,
        {
          entity_type: this.filters.entity.value.type,
          entity_id: this.filters.entity.value.id,
        }
      )
      this.$store.commit('loading', false)
    },
  },
}
